import { DateInput } from 'react-admin';

/** Always-on date range for receipt ListBase views (no text search). */
export const receiptDateRangeFilters = [
    <DateInput
        key="transaction_date_gte"
        source="transaction_date_gte"
        label="From"
        alwaysOn
    />,
    <DateInput
        key="transaction_date_lte"
        source="transaction_date_lte"
        label="To"
        alwaysOn
    />,
];
